import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Button } from './ui/Button';
const faqs = [{
  q: '¿Realmente funciona desde los primeros 7 días?',
  a: <>
        Sí. El{' '}
        <span className="bg-brand-gold/10 px-1 rounded text-brand-gold" data-id="element-74">
          80%
        </span>{' '}
        de los hombres ve resultados desde los primeros 7 días en adelante, ya
        que desde el primer entrenamiento notarás cómo te volvés más consciente
        de los músculos corporales clave para lograr controlar tu cuerpo.
        Recomendamos 30 días de consistencia para resultados completos.
      </>
}, {
  q: '¿Es seguro? ¿Tiene efectos secundarios?',
  a: <>
        <strong className="text-white" data-id="element-75">Completamente natural</strong> y seguro.
        No usás pastillas, cremas ni químicos. Solo técnicas ancestrales de
        respiración y control mental que han sido probadas por milenios.
      </>
}, {
  q: '¿Qué pasa si no me funciona?',
  a: <>
        <strong className="text-brand-gold" data-id="element-76">Garantía total</strong> de 30 días.
        Si no empezás a ver resultados reales, te devolvemos el 100% de tu
        dinero sin hacer preguntas.
      </>
}, {
  q: '¿Es solo para casos severos?',
  a: <>
        No. Funciona para cualquier nivel, desde casos de 30 segundos hasta
        hombres que duran 5 minutos pero quieren{' '}
        <strong className="text-white" data-id="element-77">más control y confianza</strong>.
      </>
}, {
  q: '¿Mi pareja se va a dar cuenta de que estoy aplicando algo?',
  a: <>
        Solo va a notar que ahora durás mucho más, tenés más confianza y{' '}
        <span className="underline decoration-brand-red/50 underline-offset-4" data-id="element-78">
          controlás completamente la experiencia
        </span>
        . Va a pensar que "algo cambió en vos" para mejor.
      </>
}, {
  q: '¿Cuánto tiempo tengo que practicar por día?',
  a: <>
        Solo <strong className="text-white" data-id="element-79">15 minutos</strong> máximo. Son
        ejercicios simples de respiración y visualización que podés hacer en
        cualquier lugar privado.
      </>
}, {
  q: '¿Funciona a cualquier edad?',
  a: <>
        Sí. Hemos tenido éxito con hombres desde los 18 hasta los 55 años. El
        método se adapta a{' '}
        <strong className="text-white" data-id="element-80">cualquier edad</strong> y condición
        física.
      </>
}, {
  q: '¿Necesito contarle a mi pareja?',
  a: <>
        No es necesario. Podés aplicar todo{' '}
        <strong className="text-white" data-id="element-81">discretamente</strong>. Ella solo va a
        notar los increíbles resultados en la cama.
      </>
}, {
  q: '¿Qué formato tiene el libro?',
  a: <>
        Es un ebook en PDF que descargás{' '}
        <strong className="text-white" data-id="element-82">inmediatamente</strong> después del pago.
        Podés leerlo en tu celular, tablet o computadora.
      </>
}, {
  q: '¿El pago es seguro?',
  a: <>
        Sí, usamos encriptación SSL y procesadores de pago certificados. Tu
        información está{' '}
        <strong className="text-brand-gold" data-id="element-83">100% protegida</strong>.
      </>
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 px-4 bg-[#0a0a0a] relative" data-id="element-84">
      <div className="max-w-3xl mx-auto" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-86">
          <span className="text-6xl mb-6 block" data-id="element-87">❓</span>
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-88">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-89">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-brand-card border border-gray-800 rounded-xl overflow-hidden" data-id="element-90">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center hover:bg-white/5 transition-colors" data-id="element-91">
                <span className="font-bold text-white pr-8" data-id="element-92">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-brand-gold shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-93" />
              </button>
              <AnimatePresence data-id="element-94">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-95">
                    <div className="px-6 pb-5 text-gray-400 leading-relaxed border-t border-gray-800/50 pt-4" data-id="element-96">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-10 text-center" data-id="element-97">
          <Button data-id="element-98">QUIERO EL MÉTODO</Button>
        </motion.div>
      </div>
    </section>;
}